import * as React from 'react'

const AppDrawerContext = React.createContext({
    menuExpanded: true,
    setMenuExpanded: (_: boolean) => {}
})

export function AppDrawerContextProvider({children}: React.PropsWithChildren) {
    const [menuExpanded, setMenuExpanded] = React.useState(true)

    return <AppDrawerContext.Provider value={{menuExpanded, setMenuExpanded}}>{children}</AppDrawerContext.Provider>
}

export function useAppDrawerContext(): {menuExpanded: boolean; setMenuExpanded: (_: boolean) => void} {
    const {menuExpanded, setMenuExpanded} = React.useContext(AppDrawerContext)

    return {menuExpanded: menuExpanded, setMenuExpanded: setMenuExpanded}
}

export function useIsAppDrawerExpanded(): boolean {
    const {menuExpanded} = React.useContext(AppDrawerContext)

    return menuExpanded
}
